import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2, ShieldCheck, ClipboardList, FileText } from 'lucide-react';

const Coproprietes = () => {
  const goToContact = () =>
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });

  const items = [
    { icon: ShieldCheck, title: 'Ravalement technique', desc: 'Diagnostic, traitement des supports, fissures et finitions adaptées au bâti parisien et haussmannien.' },
    { icon: ClipboardList, title: 'Suivi & coordination', desc: 'Organisation du chantier, échafaudage, déclarations préalables et coordination avec le syndic.' },
    { icon: FileText, title: 'Réponse aux consultations', desc: 'Étude de dossiers, devis détaillés et solutions techniques pour appels d\'offres et copropriétés.' },
  ];

  return (
    <section id="coproprietes" className="py-24 bg-slate-50 scroll-mt-28">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mb-14">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Copropriétés & Syndics
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-5">
            Un partenaire technique pour vos immeubles
          </h2>
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed">
            VIREO accompagne copropriétés, syndics et gestionnaires dans leurs travaux de ravalement,
            de rénovation et d'amélioration énergétique, avec des dossiers clairs et un suivi rigoureux.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-10">
          {items.map((it, i) => {
            const Icon = it.icon;
            return (
              <Card key={i} data-testid={`copro-item-${i}`} className="border-slate-200 hover:border-emerald-500 hover:shadow-lg transition-all duration-300 bg-white group">
                <CardContent className="p-7">
                  <div className="w-12 h-12 bg-emerald-100 rounded-xl flex items-center justify-center mb-4 group-hover:bg-emerald-600 transition-colors duration-300">
                    <Icon className="h-6 w-6 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2">{it.title}</h3>
                  <p className="text-slate-600 leading-relaxed">{it.desc}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <Card className="bg-gradient-to-br from-slate-800 to-slate-900 border-none">
          <CardContent className="p-8 md:p-10 flex flex-col md:flex-row items-center gap-6 justify-between">
            <div className="flex items-center gap-4 text-center md:text-left">
              <div className="w-14 h-14 bg-emerald-600 rounded-2xl hidden md:flex items-center justify-center flex-shrink-0">
                <Building2 className="h-7 w-7 text-white" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-1">Un projet pour votre copropriété ?</h3>
                <p className="text-slate-300">Diagnostic et devis détaillé pour syndics, conseils syndicaux et gestionnaires.</p>
              </div>
            </div>
            <button
              onClick={goToContact}
              data-testid="copro-cta"
              className="bg-white text-slate-900 hover:bg-emerald-50 px-7 py-3.5 rounded-lg font-semibold transition-colors whitespace-nowrap"
            >
              Demander une étude
            </button>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default Coproprietes;
